var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar mobile-side-nav",class:{ open: _vm.open }},[_c('div',{staticClass:"mobile-side-nav-logo"},[_c('svg-vue',{staticClass:"logo",attrs:{"icon":"logo"}})],1),_vm._v(" "),_c('base-sidebar-navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }